import { Field } from 'formik'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { TimeField } from '../../field'
import { ArrivalRouteArgs } from '../../../../../containers/TowingRecordPage/components/routes/subforms/StartRoute/types'

interface Props {
  name: string
  label?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  customOnChange?: () => void
  className?: string
  isAutoliitto?: boolean
  calculateEta?: boolean
  arrivalRoute?: ArrivalRouteArgs
  setCalculateEta?: (loading: boolean) => void
  setTimeButton?: boolean
  onSetCurrentTime?: () => void
}

export const TimeInput: React.FunctionComponent<Props> = ({
  customOnChange,
  name,
  label,
  placeholder,
  required,
  isAutoliitto,
  calculateEta,
  arrivalRoute,
  setCalculateEta,
  onSetCurrentTime,
  setTimeButton = true,
  ...rest
}) => {
  const intl = useIntl()
  const validate = useCallback(
    (value: string | null): string | undefined => {
      if (required && (!value || !value.trim())) {
        return intl.formatMessage({ id: 'validation.requiredField' })
      }

      const timeRegex = /^(([0-9])|([0-1][0-9])|([2][0-3]))(:|.(([0-9])|([0-5][0-9])))$/

      if (value && !value.match(timeRegex)) {
        return intl.formatMessage({ id: 'timeInput.invalidFormat', defaultMessage: 'Esitä aika muodossa tt:mm' })
      }

      //Conversion to tt:mm failed, e.g 12050
      if(value && value.indexOf(":") === -1) {
        return intl.formatMessage({ id: 'timeInput.invalidFormat', defaultMessage: 'Esitä aika muodossa tt:mm' })
      }
    
      return undefined
    },
    [required, intl]
  )

  return (
    <Field
      {...rest}
      component={TimeField}
      id={name}
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      validate={validate}
      customOnChange={customOnChange}
      isAutoliitto={isAutoliitto}
      calculateEta={calculateEta}
      arrivalRoute={arrivalRoute}
      setCalculateEta={setCalculateEta}
      setTimeButton={setTimeButton}
      onSetCurrentTime={onSetCurrentTime}
    />
  )
}
